import HttpClient from "../services/HttpClient";
import {
  APP_URL_CONTRACT,
} from "../constants";

export const saveRefundByRecomendationAsync = (data, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL_CONTRACT}/refund-by-recommendation`, data, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};


export const getFilterRefundRecomendation = (filters, paginator) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_CONTRACT}/refund-by-recommendation/criteria/?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const uploadRefundFilesAsync = (id, documents) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL_CONTRACT}/refund-by-recommendation/${id}/upload-document`,
      documents,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
}

export const finishRefundByRecomendationAsync = (data) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(
      `${APP_URL_CONTRACT}/refund-by-recommendation/finish`,
      data,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
}

export const cancelRefundByRecomendationAsync = (id) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(
      `${APP_URL_CONTRACT}/refund-by-recommendation/${id}/cancel`,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
}

export const getRefundByRecomendationDocumentsAsync = (id) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_CONTRACT}/refund-by-recommendation/${id}/documents`,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
}

export const dowloadReportAsync = (id, saeDocumentId) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_CONTRACT}/refund-by-recommendation/${id}/download-report/${saeDocumentId}`,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
}

